import { isAndroid, isIOS, isMobile, isTablet } from "react-device-detect";

/**
 * Mobile / tablet photo capture only — same rule as BrowserView / MobileView.
 * Do not use touch + viewport heuristics; those mis-detect desktop machines.
 */
export function isMobilePhotoDevice() {
  if (typeof window === "undefined") {
    return false;
  }

  return Boolean(isMobile || isTablet || isIOS || isAndroid);
}

export function isSecureCameraContext() {
  if (typeof window === "undefined") {
    return true;
  }

  if (window.isSecureContext) {
    return true;
  }

  const host = window.location.hostname;
  return host === "localhost" || host === "127.0.0.1" || host === "[::1]";
}
